export function getCookieFromName(name: string): string {
    const b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? (b.pop() as string) : '';
}

export function deleteCookie(name: string): void {
    // Delete cookie with default path (set by client-side JS)
    document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

    // Delete cookie with domain prefix (set by server with .domain.com)
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;

    // Delete cookie without domain prefix (set by server with domain.com)
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
}
